import {Box, FormControlLabel, InputLabel, Switch, Typography} from "@mui/material";
import {memo} from "react";

const WidgetSwitch= ({ label, value, onChange}) => {

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ height: '100%' }}
    >
      <InputLabel variant={'standard'}>
        {label}
      </InputLabel>
      <FormControlLabel
        control={
          <Switch
            size={'small'}
            checked={!!value}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
      />
    </Box>
  );
};

export default memo(WidgetSwitch);